import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { VueDAigle } from '../../types.js';
import commun from './commun.module.css';
import { LienConsole, NonComptees, Section } from './composants.js';
import { useDroitsVue } from './droits.js';
import { useFormats } from './formats.js';
import styles from './SommesDues.module.css';

/**
 * Les sommes dues : créances ouvertes, en retard, et ce qui est rentré ce
 * mois. Des totaux, jamais le nom d'un débiteur. Les créances dont le montant
 * est « à saisir » ne sont dans aucun total : le compteur le dit.
 */
export function SommesDues({ vue, numero }: { vue: VueDAigle; numero: string }): JSX.Element {
  const { t } = useTranslation('console');
  const f = useFormats();
  const { peut } = useDroitsVue(vue);
  const { sommesDues } = vue;

  return (
    <Section
      id="sommes-dues"
      numero={numero}
      titre={t('vueDAigle.sommesDues.titre')}
      note={t('vueDAigle.sommesDues.note')}
      actions={
        peut('console:manage-receivables') ? (
          <LienConsole vers="/finances?onglet=creances" bouton>
            {t('vueDAigle.sommesDues.gerer')}
          </LienConsole>
        ) : undefined
      }
    >
      <dl className={styles.tuiles}>
        <div className={commun.tuile}>
          <dt>{t('vueDAigle.sommesDues.due')}</dt>
          <dd className={commun.valeur}>{f.euros(sommesDues.dueCentimes)}</dd>
          <dd className={commun.aide}>{t('vueDAigle.sommesDues.dueAide')}</dd>
        </div>
        <div className={commun.tuile}>
          <dt>{t('vueDAigle.sommesDues.enRetard')}</dt>
          <dd
            className={`${commun.valeur} ${sommesDues.enRetardCentimes > 0 ? styles.retard : ''}`}
          >
            {f.euros(sommesDues.enRetardCentimes)}
          </dd>
          <dd className={commun.aide}>{t('vueDAigle.sommesDues.enRetardAide')}</dd>
        </div>
        <div className={commun.tuile}>
          <dt>{t('vueDAigle.sommesDues.encaisse')}</dt>
          <dd className={commun.valeur}>{f.euros(sommesDues.encaisseMoisCentimes)}</dd>
          <dd className={commun.aide}>{t('vueDAigle.sommesDues.encaisseAide')}</dd>
        </div>
      </dl>
      <NonComptees nombre={sommesDues.aSaisir} />
    </Section>
  );
}
